import psychologistService from '@/services/psychologistService';
import { getCurrentMonthNumber, getCurrentYear, getCurrentMonthName } from '@/utils/dateUtils';

export const fetchPendingTasks = async ({ commit }) => {
    try {
        commit('SET_LOADING_TASKS', true);
        const response = await psychologistService.getImpactCases(1, 1);
        
        // Obtener el mes y año actual
        const currentMonthNumber = getCurrentMonthNumber();
        const currentYear = getCurrentYear();
        const currentMonthName = getCurrentMonthName();
        
        // Obtener el último registro
        const lastRecord = response.data.data?.[0];
        
        // Verificar si el último registro es del mes actual
        const isCurrentMonthCompleted = lastRecord && 
            lastRecord.month === currentMonthNumber && 
            lastRecord.year === currentYear;
        
        // Crear la tarea del mes actual
        const task = {
            id: isCurrentMonthCompleted ? lastRecord.id : Date.now(),
            name: `Casos de Impacto - ${currentMonthName} ${currentYear}`,
            status: isCurrentMonthCompleted ? 'Completada' : 'Pendiente',
            statusClass: isCurrentMonthCompleted ? 'badge-success' : 'badge-warning'
        };
        
        const tasks = [task];
        
        commit('SET_PENDING_TASKS', tasks);
        return tasks;
    } catch (error) {
        console.error('Error fetching pending tasks:', error);
        commit('SET_PENDING_TASKS', []);
        return [];
    } finally {
        commit('SET_LOADING_TASKS', false);
    }
}
